import { render, staticRenderFns } from "./benefits-settings.vue?vue&type=template&id=719610d9&scoped=true"
import script from "./benefits-settings.vue?vue&type=script&lang=js"
export * from "./benefits-settings.vue?vue&type=script&lang=js"
import style0 from "./benefits-settings.vue?vue&type=style&index=0&id=719610d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719610d9",
  null
  
)

export default component.exports